export default {
    authjson: function (v) {
        if (!window.sessionStorage.getItem('authInfo')) return false;
        for (let i = 0; i < v.length; i++) {
            if (JSON.parse(window.sessionStorage.getItem('authInfo')).includes(v[i])) {
                return true;
            }
        }
    }
}